import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { PasswordStrength } from "./password-strength.enum";
import { PasswordTest } from "./password-test.model";

@Component({
  selector: "strength-indicator",
  template: `
    <div class="strength-indicator-container" [hidden]='touched'>
      <div class="strength-indicator"
        [ngClass]="getIndicatorName(strength)"
        [style.width]="getWidth()"
      ></div>
    </div>
  `,
  styles: [
    `
      * {
        box-sizing: border-box;
      }
      .strength-indicator-container { width: 100%;backgrond:#F5F5F5; }
      .strength-indicator { height: 3px }
      :host {
        display: block;
        width: 100%;
        margin-top: 34px;
        height:2px;
      }
      .weakest {
        background-color: red;
      }
      .weak {
        background-color: orange;
      }
      .normal {
        background-color: yellow;
      }
      .strong {
        background-color: cyan;
      }
      .strongest {
        background-color: green;
        width: 117% !important;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StrengthIndicatorComponent {
  @Input() strength: PasswordTest ;
  @Input() touched: boolean = true;
  getWidth() {
   
    const strengthIndex = this.indicators.find(i => +i=== this.strength.strength);
    return `${((+strengthIndex + 1) * 100) / this.indicators.length}%`;
  }

  getIndicatorName(indicator) {

    return PasswordStrength[indicator.strength].toLowerCase();
  }

  get indicators() {
    const keys = Object.keys(PasswordStrength);

    return keys.slice(0, keys.length / 2);
  }
}
